import { KeyboardKey } from "@/lib/constants/keyboard-keys";
import { Button, Flex, TextInput, useI18nContext } from "@procore/core-react";
import React from "react";
import { CATEGORIES_TRANSLATIONS } from "./utils";

type InlineInputProps = {
   value: string;
   onChange: (value: string) => void;
   onSave: () => void;
   onCancel: () => void;
   placeholder?: string;
   ariaLabel: string;
   isSaving?: boolean;
};

export const InlineInput = ({
   value,
   onChange,
   onSave,
   onCancel,
   placeholder,
   ariaLabel,
   isSaving = false,
}: InlineInputProps) => {
   const I18n = useI18nContext();
   return (
      <Flex alignItems="center" justifyContent="space-between" style={{ flex: 1 }}>
         <TextInput
            autoFocus
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={(e) => {
               e.stopPropagation();
               if (e.key === KeyboardKey.Enter) onSave();
               if (e.key === KeyboardKey.Escape) onCancel();
            }}
            placeholder={placeholder}
            aria-label={ariaLabel}
            style={{ maxWidth: "50%" }}
         />
         <Flex gap="xs">
            <Button variant="secondary" size="sm" onClick={onCancel}>
               {I18n.t(`${CATEGORIES_TRANSLATIONS}.cancel`)}
            </Button>
            <Button size="sm" loading={isSaving} onClick={onSave}>
               {I18n.t(`${CATEGORIES_TRANSLATIONS}.save`)}
            </Button>
         </Flex>
      </Flex>
   );
};
